import { Stack, Switch } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { WebBotProviderData } from '@/API';

interface WebBotFeaturesTabProps {
  form: UseFormReturnType<WebBotProviderData>;
}

export function WebBotFeaturesTab({ form }: WebBotFeaturesTabProps) {
  const feat = form.values.features;

  return (
    <Stack gap="md">
      <Switch
        label="顯示清空聊天紀錄按鈕"
        description="開啟後將顯示清空聊天紀錄按鈕，允許使用者重新開始對話"
        checked={feat?.enableClearHistoryButton ?? false}
        {...form.getInputProps('features.enableClearHistoryButton', { type: 'checkbox' })}
      />
      <Switch
        label="啟用 Stream 串流回應模式"
        description="開啟後機器人回應將以流式 (Stream) 逐字/逐塊即時輸出"
        checked={feat?.enableStreamMode ?? false}
        {...form.getInputProps('features.enableStreamMode', { type: 'checkbox' })}
      />
      <Switch
        label="顯示評價按鈕 (回應良好/回應欠佳)"
        description="開啟後將在機器人回覆訊息下方顯示回應良好與回應欠佳按鈕"
        checked={feat?.enableFeedbackRatingButtons ?? false}
        {...form.getInputProps('features.enableFeedbackRatingButtons', { type: 'checkbox' })}
      />
      <Switch
        label="顯示回報問題按鈕"
        description="開啟後將在機器人回覆訊息下方顯示回報問題按鈕，允許使用者填寫反饋訊息"
        checked={feat?.enableReportIssueButton ?? false}
        {...form.getInputProps('features.enableReportIssueButton', { type: 'checkbox' })}
      />
    </Stack>
  );
}
